export const DEFAULT_APP_BRANDING = {
  // Sidebar brand mark — unaffected by the loader/favicon below.
  logo: "/logo.png",
  // Boot splash / route-loading mark and the browser tab icon, sourced from
  // the qf mark set rather than the sidebar's logo.png. The mark is blue-on-
  // transparent, so it needs a light-background variant and a white-on-
  // transparent one for the dark boot/loading background.
  loaderLogo: "/qf/blue_logo_no_text_cropped.png",
  loaderLogoDark: "/qf/white_logo_no_text_cropped.png",
  favicon: "/qf/white-favicon.ico",
};

export const TENANT_BRANDING = {
  limelight: {
    // The tenant's own square icon leads only in the sidebar (BrandLogo) —
    // the boot splash and favicon always stay the app's own qf mark, never
    // a tenant's. logo is the wider wordmark lockup, kept only as the
    // sidebar fallback for a tenant with no icon of its own.
    logo: "/assets/images/limelight_black_logo.svg",
    logoIcon: "/assets/images/limelight-icon.svg",
    // The wordmark cropped out of the logo itself, so the title reads in the
    // brand's own lettering rather than being reset in the app's system font.
    // It's black-on-transparent, so dark mode swaps in the white cut.
    wordmark: "/assets/images/limelight-wordmark.svg",
    wordmarkDark: "/assets/images/limelight-wordmark-white.svg",
    label: "Limelight",
  },
};

export function resolveTenant(hostname, configuredTenant = "") {
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  if (isLocalhost && typeof configuredTenant === "string" && configuredTenant.trim()) {
    return configuredTenant.trim().toLowerCase();
  }
  if (isLocalhost) return "";

  return hostname.split(".")[0]?.toLowerCase() ?? "";
}
